import { useMemo, useReducer } from 'react'
import Fuse from 'fuse.js'

const increment = (x: number) => x + 1
export function useForceUpdate() {
  return useReducer(increment, 0)[1]
}

export function useFuse<T>({
  items,
  keys,
  query,
  limit,
}: {
  items: T[]
  keys: (keyof T)[]
  query: string
  limit?: number
}) {
  const fuse = useMemo(() => {
    return new Fuse(items, {
      keys: keys as string[],
      ignoreLocation: true,
      includeScore: true,
    })
  }, [items])

  return useMemo(
    () =>
      query
        ? fuse
            .search(query, { limit })
            .filter(({ score }) => score < 0.3)
            .map(({ item }) => item)
        : items,
    [query, fuse, items],
  )
}
